import {
  action$,
  dispatchAction,
  extractPayload,
  ObservableState,
  ofType,
} from '@ardoq/rxbeach';
import { selectionEnd } from '../actions/navigatorActions';
import {
  componentTreeSelectionChanged,
  componentTreeSelectionStartSelected,
  ComponentSelection,
} from '@ardoq/component-selection';
import { filter, Observable, tap, withLatestFrom } from 'rxjs';
import { NavigatorLayoutState, RangeSelectionMode } from '../types';

export const toRangeSelection = (
  rangeSelectionMode: RangeSelectionMode,
  currentSelection: string[],
  range: string[]
): string[] =>
  rangeSelectionMode === 'extendSelection'
    ? [...new Set([...currentSelection, ...range])]
    : range;

type GetHandleSelectionEndArgs = {
  navigator$: Observable<NavigatorLayoutState>;
  componentSelection$:
    | ObservableState<ComponentSelection>
    | Observable<ComponentSelection>;
  rangeSelectionMode: RangeSelectionMode;
  actionNamespace?: string;
};

export const getHandleSelectionEnd = ({
  navigator$,
  componentSelection$,
  rangeSelectionMode,
  actionNamespace,
}: GetHandleSelectionEndArgs) =>
  action$.pipe(
    ofType(selectionEnd),
    // Strict namespacing, `withNamespace` also lets pass no-namespaced actions.
    filter(({ meta: { namespace } }) => namespace === actionNamespace),
    extractPayload(),
    withLatestFrom(navigator$, componentSelection$),
    tap(([{ nodeId }, { tree }, { treeSelection, selectionStart }]) => {
      const node = tree.getNode(nodeId);
      if (!node || !node.isSelectable || node.isDisabledOption) {
        return;
      }
      if (!selectionStart) {
        dispatchAction(
          componentTreeSelectionStartSelected({ selectionStart: nodeId }),
          actionNamespace
        );
        return;
      }
      const range = tree.updateRange(selectionStart, nodeId);
      dispatchAction(
        componentTreeSelectionChanged({
          treeSelection: toRangeSelection(
            rangeSelectionMode,
            treeSelection,
            range
          ),
        }),
        actionNamespace
      );
    })
  );
